import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface SessionStore {
  authToken: string | null
  hasHydrated?: boolean
  hasGuestUserSaved?: boolean
  userEmail: string | null
  userId: string | null
  userRoles: string[]
  mobileVerified: boolean
  termsAccepted: boolean
  setAuth: (
    token: string | null,
    userId: string | null,
    userEmail: string | null,
    userRoles?: string[],
    mobileVerified?: boolean,
    termsAccepted?: boolean,
  ) => void
  setHasHydrated: (state: boolean) => void
  setHasGuestUserSaved: (hasGuestUserSaved: boolean) => void
  setMobileVerified: (mobileVerified: boolean) => void
  setTermsAccepted: (termsAccepted: boolean) => void
  clearSession: () => void
}

export const SESSION_STORE_KEY = 'session-store'

const useSessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      authToken: null,
      hasHydrated: false,
      hasGuestUserSaved: false,
      userId: null,
      userEmail: null,
      userRoles: [],
      mobileVerified: false,
      termsAccepted: false,
      setAuth: (token, userId, userEmail, userRoles = [], mobileVerified, termsAccepted) =>
        set((state) => ({
          authToken: token,
          userId,
          userEmail,
          userRoles,
          mobileVerified:
            typeof mobileVerified === 'boolean'
              ? mobileVerified
              : token
                ? state.mobileVerified
                : false,
          termsAccepted:
            typeof termsAccepted === 'boolean'
              ? termsAccepted
              : token
                ? state.termsAccepted
                : false,
        })),
      setHasHydrated: (state) => {
        set({
          hasHydrated: state,
        })
      },
      setHasGuestUserSaved: (hasGuestUserSaved: boolean) => set({ hasGuestUserSaved }),
      setMobileVerified: (mobileVerified: boolean) => set({ mobileVerified }),
      setTermsAccepted: (termsAccepted: boolean) => set({ termsAccepted }),
      clearSession: () =>
        set(() => ({
          authToken: null,
          userId: null,
          userEmail: null,
          userRoles: [],
          hasGuestUserSaved: false,
          mobileVerified: false,
          termsAccepted: false,
        })),
    }),
    {
      name: SESSION_STORE_KEY,
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      },
    },
  ),
)

export default useSessionStore
